import Button from '../../../Button/Button';
import ButtonGroup from '../../../Button/ButtonGroup/ButtonGroup';
import React, { useRef, useState } from 'react';
import SpaceAssetsModalInfo from './SpaceAssetsModalInfo';

const SpaceAssetsSelectorModalFooter = (props) => {
  const {
    closeModal,
    totalAssestsSelectedValue,
    spaceAsstesPickedCount,
    messageComponent,
    isResponsive,
    isJsonRTE,
    isInline,
    embedAsLink,
    linkSettings,
    mode,
    executeMove,
    onMoveComplete,
    onMoveError,
    onFilesSelected,
    uploadFileAccept,
    selectedFolder,
    onCreateFolderClick,
    showSuggestionsFeedback,
    onSuggestionsFeedbackVote,
  } = props;
  const isMoveTarget = mode === 'moveTarget';
  const isUploadTarget = mode === 'uploadTarget';
  const [isMoving, setIsMoving] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleMoveHere = async () => {
    if (!executeMove) return;
    setIsMoving(true);
    try {
      const targetFolderUid = selectedFolder ? selectedFolder.uid : 'root';
      const folderName = selectedFolder ? selectedFolder.title : 'root';
      await executeMove(targetFolderUid, folderName);
      onMoveComplete?.();
      closeModal();
    } catch (error) {
      onMoveError?.(error);
      closeModal();
    }
  };

  if (isMoveTarget) {
    return (
      <>
        <SpaceAssetsModalInfo
          messageComponent={messageComponent}
          isResponsive={isResponsive}
          showSuggestionsFeedback={showSuggestionsFeedback}
          onSuggestionsFeedbackVote={onSuggestionsFeedbackVote}
        />
        <ButtonGroup>
          <Button
            aria-label="Cancel"
            testId="cs-bulk-move-cancel-btn"
            buttonType="tertiary"
            version="v2"
            size={isResponsive ? 'small' : 'medium'}
            onClick={(): void => {
              closeModal();
            }}>
            Cancel
          </Button>
          <Button
            aria-label="Create New Folder"
            testId="cs-bulk-move-create-folder-btn"
            buttonType="secondary"
            version="v2"
            size={isResponsive ? 'small' : 'medium'}
            onClick={(): void => {
              onCreateFolderClick?.();
            }}>
            Create Folder
          </Button>
          <Button
            aria-label="Move Here"
            testId="cs-bulk-move-move-btn"
            version="v2"
            size={isResponsive ? 'small' : 'medium'}
            isLoading={isMoving}
            onClick={handleMoveHere}>
            Move Here
          </Button>
        </ButtonGroup>
      </>
    );
  }

  if (isUploadTarget) {
    const targetFolderUid = selectedFolder ? selectedFolder.uid : 'root';

    const handleUploadAssetsClick = () => {
      fileInputRef.current?.click();
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const files = e.target.files;
      if (!files || files.length === 0) return;
      onFilesSelected?.(files, targetFolderUid);
      closeModal();
    };

    return (
      <>
        <SpaceAssetsModalInfo
          messageComponent={messageComponent}
          isResponsive={isResponsive}
          showSuggestionsFeedback={showSuggestionsFeedback}
          onSuggestionsFeedbackVote={onSuggestionsFeedbackVote}
        />
        <ButtonGroup>
          <Button
            aria-label="Cancel"
            testId="cs-upload-target-cancel-btn"
            buttonType="tertiary"
            version="v2"
            size={isResponsive ? 'small' : 'medium'}
            onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button
            aria-label="Create New Folder"
            testId="cs-upload-target-create-folder-btn"
            buttonType="secondary"
            version="v2"
            size={isResponsive ? 'small' : 'medium'}
            onClick={() => onCreateFolderClick?.()}>
            Create New Folder
          </Button>
          <Button
            aria-label="Upload Assets"
            testId="cs-upload-target-upload-btn"
            version="v2"
            size={isResponsive ? 'small' : 'medium'}
            onClick={handleUploadAssetsClick}>
            Upload Assets
          </Button>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept={uploadFileAccept}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </ButtonGroup>
      </>
    );
  }

  return (
    <>
      {/* Message/Info */}
      <SpaceAssetsModalInfo
        messageComponent={messageComponent}
        isResponsive={isResponsive}
        showSuggestionsFeedback={showSuggestionsFeedback}
        onSuggestionsFeedbackVote={onSuggestionsFeedbackVote}
      />

      {/* Buttons CTA */}
      <ButtonGroup>
        <Button
          aria-label="Cancel"
          testId="am-v2-space-assets-entry-choose-file-cancel"
          buttonType="tertiary"
          version="v2"
          size={isResponsive ? 'small' : 'medium'}
          onClick={(): void => {
            closeModal();
          }}>
          Cancel
        </Button>
        <Button
          aria-label="Add Selected Assets"
          testId="am-v2-space-assetsentry-choose-file-add-selected-entries"
          version="v2"
          size={isResponsive ? 'small' : 'medium'}
          disabled={totalAssestsSelectedValue.filter((fi) => !fi.is_dir).length ? false : true}
          onClick={(): void => {
            if (props.setUploadAssetFlag) {
              props.setUploadAssetFlag(true);
            }
            const arr = totalAssestsSelectedValue.map((obj: any) => {
              if (!obj.is_dir) {
                return { file: obj };
              }
            });
            if (embedAsLink) {
              closeModal(arr, { linkSettings });
            } else if (isJsonRTE) {
              closeModal(arr, { isInline });
            } else {
              closeModal(arr);
            }
          }}>{`Use Selected Assets (${spaceAsstesPickedCount})`}</Button>
      </ButtonGroup>
    </>
  );
};

export default SpaceAssetsSelectorModalFooter;
